import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { ContractChangeStatusEnum } from 'gql/graphql';

import { useCallback, useMemo } from 'react';

import { updateAgreement } from '../AgreementsQueries';

import { useAgreementItem } from './useAgreementItem';

export const useEditAgreementItem = ({
    currentAgreementItemId,
}: {
    currentAgreementItemId: number | null | undefined;
}) => {
    const { agreementItemData, agreementItemStatus, resetAgreementItem } = useAgreementItem({
        currentAgreementItemId,
    });

    const [agreementEditData, agreementEditStatus, agreementEditError, agreementEditRequest] = useRequest({
        requestId: 'agreementEdit',
        query: updateAgreement,
        withEffect: false,
    });
    const [resetAgreementsEditData] = useResetStoreData({ requestId: 'agreementEdit' });

    const isSavingInProgress = useMemo(() => agreementEditStatus === RequestStatus.FETCHING, [agreementEditStatus]);
    const isFetchingDataForDisplayInProgress = useMemo(
        () => agreementItemStatus === RequestStatus.FETCHING,
        [agreementItemStatus],
    );
    const isStatusAfterUpdateApproved = useMemo(
        () => agreementEditData?.uerUpdateContractChange?.data?.status === ContractChangeStatusEnum.Approved,
        [agreementEditData?.uerUpdateContractChange?.data?.status],
    );

    const resetEditData = useCallback(() => {
        resetAgreementsEditData(null);
        resetAgreementItem(null);
    }, [resetAgreementItem, resetAgreementsEditData]);

    return {
        agreementItemData,
        isFetchingDataForDisplayInProgress,
        resetEditData,
        agreementEditData: agreementEditData?.uerUpdateContractChange,
        agreementEditStatus,
        isStatusAfterUpdateApproved,
        agreementEditError,
        agreementEditRequest,
        isSavingInProgress,
    };
};
